import { MyMedicalPaOrdersTableData } from "../../../../data-model/tablesData";
import { useFilterAndSearchEffect } from "./useFilterAndSearchEffect";
import { useFilterPayload } from "./useFilterPayload";
import { MyMedicalPaOrdersState } from "./useMyPaOrdersTableData";
import { usePaginationReset } from "./usePaginationReset";
import { useSearchTerm } from "./useSearchTerm";
import { useValidFilters } from "./useValidFilters";

export const useFilterAndSearch = (
  initialDataFetchingExecuted: boolean,
  setTableData: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersTableData[]>
  >,
  setMyMedicalPaOrdersState: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersState>
  >,
) => {
  const { searchTerm, setSearchTerm } = useSearchTerm();
  const { paginationResetCount, setPaginationResetCount } =
    usePaginationReset();
  const validFilters = useValidFilters();
  const { filterPayload } = useFilterPayload(
    validFilters,
    searchTerm,
    initialDataFetchingExecuted,
  );

  useFilterAndSearchEffect(
    filterPayload,
    initialDataFetchingExecuted,
    setTableData,
    setMyMedicalPaOrdersState,
    setPaginationResetCount,
  );

  return {
    filterPayload,
    searchTerm,
    setSearchTerm,
    paginationResetCount,
    setPaginationResetCount,
    validFilters,
  };
};
